module.exports = __webpack_public_path__ + "static/media/pres_pgs03.4f0ae500.png";